/* @flow */

import mensagemSucesso from './mensagem-sucesso';
import { cadastrarUrlsLojas, getDadosFormularioUrlLojas } from '../eventos-formularios/urls-lojas';
import exibirErro from '../../utils/exibir-erro';
import getElementoPorId from '../../utils/get-elemento-por-id';
import proximaEtapa from './proximaEtapa';
import getInputPorId from '../../utils/get-input-por-id';

const cadastroUrlsLojas = (empresasId: number) => {
    const inputDownloadUrlLoja = getInputPorId('download-empresas-urls-lojas');
    const iconBloquearEdicaoUrlDownload = document.getElementById('desbloquear-input-download');
    inputDownloadUrlLoja.value = '';
    inputDownloadUrlLoja.disabled = false;
    getInputPorId('ios-empresas-urls-lojas').value = '';
    getInputPorId('android-empresas-urls-lojas').value = '';

    if (iconBloquearEdicaoUrlDownload) {
        iconBloquearEdicaoUrlDownload.hidden = true;
    }

    const form = getElementoPorId('formulario-urls-lojas');
    form.onsubmit = async (e) => {
        e.preventDefault();
        try {
            cadastrarUrlsLojas(empresasId, getDadosFormularioUrlLojas());
            mensagemSucesso('Urls cadastradas');
            proximaEtapa('item-packages');
        } catch (err) {
            exibirErro(err);
        }
    };
};

export default cadastroUrlsLojas;
